import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPop_osComponent } from './simple-icons-pop_os.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPop_osComponent ],
    exports:      [ SimpleIconsPop_osComponent ],
    bootstrap:    []
})
export class SimpleIconsPop_osModule {}
